module.exports = __webpack_public_path__ + "static/media/ketogains-tm.b7440c3a.svg";